import React from "react";
import { Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { stats } from "../../../utils/data"; // Importing stats data
import StarField from "../StarField";

const HeroSection = () => {
  const navigate = useNavigate();

  const handleStartNow = () => {
    navigate("/kyc");
  };

  return (
    <Row className="align-items-center justify-content-center hero-container position-relative">
      <StarField />
      {/* Glowing background elements */}
      <div className="hero-glow position-absolute top-0 start-50 translate-middle-x"></div>

      <Col
        lg={6}
        className="d-flex position-relative  align-items-center justify-content-center flex-column text-center px-lg-5 px-4 w-100 w-lg-auto"
      >
        {/* Hero content animation */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          {/* Hero badge */}
          <div className="hero-badge d-inline-flex align-items-center rounded-4 mb-3">
            <span className="badge-icon">🚀</span>
            <span className="badge-text">Next Generation Crypto Platform</span>
          </div>

          {/* Hero title */}
          <motion.h1
            className="hero-title mb-2"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.8 }}
          >
            The Future of <span className="highlight">Digital Finance</span>{" "}
            <br /> is Here
          </motion.h1>

          {/* Hero subtitle */}
          <motion.p
            className="hero-subtitle mb-3 text-center text-muted"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.8 }}
          >
            Experience seamless trading, real-time analytics, and secure
            transactions with our cutting-edge cryptocurrency platform.
          </motion.p>

          {/* Action buttons */}
          <motion.div
            className="d-flex gap-4 justify-content-center align-items-center mb-5"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6, duration: 0.8 }}
          >
            <button className="btn btn-outline" onClick={handleStartNow}>
              <span className="z-1 position-relative fw-bold">Start Now</span>
            </button>
          </motion.div>

          {/* Stats section */}
          <motion.div
            className="hero-stats"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.8, duration: 0.8 }}
          >
            {/* Displaying stats dynamically */}
            {stats.map((stat, index) => (
              <div key={index} className="stat-card">
                <h3>{stat.value}</h3>
                <p>{stat.label}</p>
              </div>
            ))}
          </motion.div>
        </motion.div>
      </Col>
    </Row>
  );
};

export default HeroSection;
